"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerCompanyEditPageActions;
(function (CustomerCompanyEditPageActions) {
    CustomerCompanyEditPageActions["Loaded"] = "Loaded";
})(CustomerCompanyEditPageActions || (CustomerCompanyEditPageActions = {}));
exports.default = CustomerCompanyEditPageActions;
